/**
 * Copyright (c) 2021 BlockDev AG
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, { FC } from 'react';
import styles from './Footer.module.scss';

export const Footer: FC = () => {
    return (
        <footer className={styles.wrapper}>
            <p>
                BlockDev AG, Seestrasse 5 CH-6300 Zug, Switzerland. Read our Website Privacy Policy
                and Terms &amp; Conditions.
            </p>
            <p>
                Mysterium Network is developed by Blockdev AG.Discovery services within Mysterium
                Network are run by NetSys Inc.
            </p>
            © 2021 Mysterium Network.
        </footer>
    );
};
